export default __webpack_public_path__ + "static/FKRomanStandard-6961b9b248866952d6c222507c3df00b.woff2";